import * as React from "react";
import { StaticImage } from "gatsby-plugin-image";
import CookieConsent from "react-cookie-consent";
import { Link } from "gatsby";
import Marquee from "react-fast-marquee";
import { Helmet } from "react-helmet";
import { useMediaQuery } from "react-responsive";

function PageLayout(props) {
  const [isOpen, setOpen] = React.useState(false);
  const [email, setEmail] = React.useState("");

  function ToggleMenu() {
    setOpen(!isOpen);
  }

  function SubmitEmail(e) {
    e.preventDefault();

    console.log("Sending email: " + email);

    setEmail(email.trim().toLowerCase());

    if (!email.includes("@")) {
      // no email
    }

    fetch("https://connect.mailerlite.com/api/subscribers", {
      method: "POST",
      body: JSON.stringify({ email }),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${process.env.MAILERLITE_API_KEY}`,
      },
    }).then((res) => {
      alert("Check your email for confirmation!");
      setEmail("");
    });
  }

  const isMobileOrTablet = useMediaQuery({ query: "(max-width: 1224px)" });

  return (
    <>
      <Helmet>
        <link rel="icon" type="image/png" href="/favicon.png" />
      </Helmet>

      <div className="h-auto min-h-screen flex flex-col bg-blue-300">
        <Marquee
          className="!absolute top-0 w-screen text-white bg-indigo-700 shadow-lg py-2"
          speed={70}
        >
          <span className="mr-8">
            Exciting news: The{" "}
            <b>Jobsworth Community Newsletter Software Project</b> has been
            announced!{" "}
            <Link className="underline" to="/communitynewsletter">
              Click here to read the full announcement!
            </Link>
          </span>
        </Marquee>
        <header className="h-52 p-2 md:p-8 flex flex-col md:flex-row md:items-end justify-between pt-14 bg-[url('../images/jobsworth-banner.png')] bg-no-repeat bg-cover bg-left bg-scroll">
          <StaticImage
            src="../images/council_logo.png"
            className="w-14 h-14 md:w-32 md:h-32"
            alt="parish council logo depicting a lighthouse light piercing through the sun"
          />
          <div className="flex flex-row items-end">
            <h1
              className="font-semibold font-display text-left text-3xl md:text-5xl text-white"
              style={{
                textShadow:
                  "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000, 0px 4px 2px rgba(0,0,0,0.76)",
              }}
            >
              Jobsworth Parish Council
            </h1>
            <button
              className="md:hidden block  bg-yellow-600 p-4 text-white"
              onClick={ToggleMenu}
            >
              Menu
            </button>
          </div>
          <div className="w-32 h-32 hidden md:block" />
        </header>
        <menu
          className={`${
            isOpen ? "flex" : "hidden"
          } absolute w-full shadow-md top-52 z-10 md:top-0 md:relative md:flex flex-col md:flex-row md:justify-around bg-yellow-600 `}
        >
          <li className="p-2 cursor-pointer text-white hover:bg-yellow-800 ">
            <Link to="/">Home</Link>
          </li>
          <li className="p-2 cursor-pointer text-white hover:bg-yellow-800 ">
            <Link to="/parish">The Parish</Link>
          </li>
          <li className="p-2 cursor-pointer text-white hover:bg-yellow-800 ">
            <Link to="/council">The Council</Link>
          </li>
          <li className="p-2 cursor-pointer text-white hover:bg-yellow-800 ">
            <Link to="/communitynewsletter">
              Jobsworth Community Newsletter Software Project
            </Link>
          </li>
          <li className="p-2 cursor-pointer text-white hover:bg-yellow-800 ">
            <Link to="/lighthouse">Lighthouse Restoration Project</Link>
          </li>
          <li className="p-2 cursor-pointer text-white hover:bg-yellow-800 ">
            <Link to="/contact">Contact</Link>
          </li>
        </menu>
        <div className="flex flex-col justify-between flex-1">
          <main className="bg-blue-50 p-8 md:max-w-4xl w-full min-h-64 mx-auto h-auto shadow-2xl">
            {props.children}
          </main>
          <footer className="mb-24 md:mb-0  bg-blue-200 shadow-inner">
            <div className="px-16 md:px-0 flex flex-row justify-center">
              <div className="flex flex-col lg:flex-row items-center justify-between md:justify-center py-16 px-16">
                <div className="flex items-center justify-center flex-col md:mr-16 xl:mr-64">
                  <p className="text-lg mb-8">
                    Live locally? Want to know what's going on? Then subscribe
                    to our update service. -- it's FREE!
                  </p>
                  <form className="flex flex-col" onSubmit={SubmitEmail}>
                    <input
                      className="p-4 mb-2"
                      type="email"
                      required
                      placeholder="your@email.com"
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                    ></input>
                    <button className="p-4 bg-yellow-600 text-white cursor-pointer hover:bg-yellow-800">
                      Subscribe
                    </button>
                  </form>
                </div>
                <div className="mt-8 lg:hidden">
                  <a href="https://store.steampowered.com/app/2749340/Jobsworth_Weekly/">
                    <StaticImage
                      height={128}
                      src="../images/wishlist.png"
                      alt="slide3"
                    />
                  </a>
                </div>
                <div className="hidden lg:block">
                  <iframe
                    src="https://store.steampowered.com/widget/2749340/"
                    frameborder="0"
                    title="steam widget"
                    width="646"
                    height="190"
                  ></iframe>
                </div>
              </div>
            </div>
            <p className="text-center text-sm py-2 m-0 bg-blue-800 text-white">
              © Jobsworth Parish Council 2024 - Website by Half Frame Limited
            </p>
          </footer>
        </div>
        <CookieConsent
          enableDeclineButton
          disableStyles={true}
          containerClasses="bg-yellow-600 bottom-0 items-baseline flex justify-between left-0 fixed w-full z-50 text-white px-4 py-2  flex-wrap"
          buttonClasses="p-4 bg-yellow-600 text-white cursor-pointer hover:bg-yellow-800"
          buttonText="I accept"
          decl
        >
          Jobsworth is a proud user of internet cookies to provide it's
          residents with a first class browsing experience. Cookies are used to
          collect anonymous analytics only.
        </CookieConsent>
      </div>
    </>
  );
}

export { PageLayout };
